import { ReactNode } from 'react';

import { LegViewCtx, LegView } from './leg-view';

/**
 * A utility provider to help pass legs down via context.
 */
export function RfqBuilderLegProvider({
  legView,
  children,
}: {
  readonly legView: LegView;
  readonly children: ReactNode;
}) {
  return <LegViewCtx.Provider value={legView}>{children}</LegViewCtx.Provider>;
}
